import type * as ScrollAreaPrimitive from "@radix-ui/react-scroll-area";
import type { ComponentPropsWithoutRef, ComponentRef } from "react";

import { DefinedDefaults } from "@/ui/lib/types";

/*-------------------------------------
|  Constants
-------------------------------------*/

export const SCROLL_AREA_ROOT_CLASS = "relative overflow-hidden";

export const SCROLL_AREA_HORIZONTAL_ROOT_CLASS = "overflow-visible";

export const SCROLL_AREA_VIEWPORT_CLASS = "size-full rounded-[inherit]";

export const SCROLL_BAR_CLASS = "flex touch-none select-none transition-colors";

export const SCROLL_BAR_ORIENTATION_CLASS_MAP = {
  vertical: "h-full w-2.5 border-l border-l-transparent p-px",
  horizontal: "absolute bottom-0 left-0 right-0 h-2.5 translate-y-full flex-col border-t border-t-transparent p-px",
} as const;

export const SCROLL_BAR_THUMB_CLASS = "relative flex-1 rounded-full bg-surface-elevated";

/*-------------------------------------
|  Types
-------------------------------------*/

export type TScrollBarOrientation = keyof typeof SCROLL_BAR_ORIENTATION_CLASS_MAP;

export type TScrollAreaOrientation = TScrollBarOrientation | "both";

export type TScrollAreaElement = ComponentRef<typeof ScrollAreaPrimitive.Root>;

export type TScrollAreaProps = ComponentPropsWithoutRef<typeof ScrollAreaPrimitive.Root> & {
  orientation?: TScrollAreaOrientation;
};

export type TScrollBarElement = ComponentRef<typeof ScrollAreaPrimitive.ScrollAreaScrollbar>;

export type TScrollBarProps = ComponentPropsWithoutRef<typeof ScrollAreaPrimitive.ScrollAreaScrollbar>;

/*-------------------------------------
|  Defaults
-------------------------------------*/

export const SCROLL_AREA_DEFAULTS = {
  orientation: "vertical",
} satisfies DefinedDefaults<TScrollAreaProps, "orientation">;

export const SCROLL_BAR_DEFAULTS = {
  orientation: "vertical",
} satisfies DefinedDefaults<TScrollBarProps, "orientation">;
